import packageJson from '../package.json';

export default packageJson.version;
